<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'QACategoryCenter',
            to: {
              name: 'QACategoryCenter'
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'QACategoryEdit',
              params: {
                id: $route.params.id
              }
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>修改分類</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 類別 -->
    <QACategoryCreateEdit></QACategoryCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import QACategoryCreateEdit from '@/views/G-3__QACategory/c/QACategoryCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    QACategoryCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('qacategory', ['qacategory']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getQACategory(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('qacategory', {
      getQACategory: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'QACategoryCenter' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.qacategory.title) {
            this.errors.push('標題 required.');
          } else if (!this.qacategory.bu_id) {
            this.errors.push('BU required.');
          } else if (!this.qacategory.support_categories_id) {
            this.errors.push('類別 required.');
          }
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.qacategory).then(() => {
            this.$router.push({ name: 'QACategoryCenter' });
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
